import {getCurrencySeparator} from './countrySetting'

export function fieldsToDataToSend(fields) {
  let dataToSend = {}

  fields.forEach((field) => {
    let value = field.value;

    if (field.isCurrency) {
      if (getCurrencySeparator() === ',') {
        value = value.replace('.', '').replace(' ', '').replace(',', '.');
      }
      else {
        value = value.replace(',', '').replace(' ', '') ;
      }
    }

    if(field.isNullable && value == ''){
      value = null;
    }

    dataToSend[field.name] = value;
  })

  return dataToSend;
}
